import { Routes } from '@angular/router';
import { PersonstammListComponent } from './list/personstamm-list.component';
import { PersonstammDetailComponent } from './detail/personstamm-detail.component';
import { canActivateAuthorization } from 'app/security/authorization.guard';
import { ErweiterungConfigResponse, PermissionResponse } from 'app/core/base-api';
import { PersonSearchResultComponent } from './list/person-search-result/person-search-result.component';
import { PersonStammSearchResolver } from './list/person-search-result/person-search-resolver';
import { PersonstammSucheComponent } from './suche/personstamm-suche.component';
import { canActivateErweiterung } from 'app/security/erweiterung.guard';
import { PersonstammListResolver } from './list/personstamm-list-resolver';
import { PersonstammAlertService } from './personstamm-alert.service';
import PermissionsEnum = PermissionResponse.PermissionsEnum;
import ActiveErweiterungenEnum = ErweiterungConfigResponse.ActiveErweiterungenEnum;

export const PersonRoutes: Routes = [
  {
    path: 'person',
    loadChildren: () => routes,
    providers: [PersonstammAlertService, PersonStammSearchResolver, PersonstammListResolver]
  }
];

export const PersonstammRoutes: Routes = [
  {
    path: 'stammpersonen',
    loadChildren: () => routes,
    providers: [PersonstammAlertService, PersonStammSearchResolver, PersonstammListResolver]
  }
];

const routes: Routes = [
  {
    path: '',
    component: PersonstammSucheComponent,
    canActivate: [canActivateAuthorization, canActivateErweiterung],
    data: {
      permissions: [PermissionsEnum.PERSON_ZPV_REGISTER],
      erweiterung: [
        ActiveErweiterungenEnum.ZENTRALE_PERSONEN_ZPV,
        ActiveErweiterungenEnum.ZENTRALE_PERSONEN_GERES,
        ActiveErweiterungenEnum.ZENTRALE_PERSONEN_KDM,
        ActiveErweiterungenEnum.ZENTRALE_PERSONEN_NEST
      ],
      breadcrumb: 'personstamm.search.breadcrumb',
      breadcrumbStatus: 'firstLevel'
    }
  },
  {
    path: 'list/searchZpv',
    component: PersonSearchResultComponent,
    canActivate: [canActivateAuthorization, canActivateErweiterung],
    data: {
      permissions: [PermissionsEnum.PERSON_ZPV_REGISTER],
      erweiterung: [
        ActiveErweiterungenEnum.ZENTRALE_PERSONEN_ZPV,
        ActiveErweiterungenEnum.ZENTRALE_PERSONEN_GERES,
        ActiveErweiterungenEnum.ZENTRALE_PERSONEN_KDM,
        ActiveErweiterungenEnum.ZENTRALE_PERSONEN_NEST
      ],
      breadcrumb: 'shared.breadcrumb.list',
      breadcrumbStatus: 'secondLevel'
    },
    resolve: {
      entity: PersonStammSearchResolver
    }
  },
  {
    path: 'list/:searchMode',
    component: PersonstammListComponent,
    data: {
      breadcrumb: 'Suchergebnis',
      breadcrumbStatus: 'secondLevel'
    },
    resolve: {
      listLoader: PersonstammListResolver
    }
  },
  {
    path: 'eigentuemer/auszug/:id',
    component: PersonstammDetailComponent
  },
  {
    path: 'uebrigeberechtigte/auszug/:id/:versionId',
    component: PersonstammDetailComponent
  },
  {
    path: 'glaeubiger/auszug/:id/:versionId',
    component: PersonstammDetailComponent
  },
  {
    path: 'eigentuemer/verhaeltnisse/:id/:versionId',
    component: PersonstammDetailComponent
  },
  {
    path: 'eigentuemer/verhaeltnisse',
    component: PersonstammDetailComponent
  },
  {
    path: 'detail/:id/:versionId',
    component: PersonstammDetailComponent
  },
  {
    path: 'detail/:id',
    component: PersonstammDetailComponent
  },
  {
    path: 'detail',
    component: PersonstammDetailComponent
  }
];
